<template>
  <zm-table
    class="comparison-table"
    stripe
    default-expand-all
    :span-method="arraySpanMethod"
    :use-flip="false"
    :data="treeData"
    :indent="0"
    row-key="id"
    :tree-props="{children: 'children'}"
    @row-click="handleRowClick"
    header-row-class-name="comparison-table-header"
    header-cell-class-name="comparison-table-header-cell"
    :style="`width: ${width}`"
    :max-height="maxHeight"
  >
    <zm-table-column
      class-name="comparison-table__feature-col">
      <template  slot-scope="scope" >
        <div :class="scope.row.subTitle ? `${scope.row.id}-sub-title` : ''">
          <span :aria-labelby="`${scope.row.id}_feature`" :class="[scope.row.subTitle ? 'sub-title' : 'sub-text', scope.row.footerDesc ? 'sub-title__footer':'']">
            <template v-if='Array.isArray(scope.row.feature)'>
              <div v-for='(item,index) in scope.row.feature' :key='index'>
                 <span tabindex="-1" :id="`${scope.row.id}_${index}_feature`" v-html="item" style="margin-right: 4px;"></span>
              </div>
            </template>
            <span v-else tabindex="-1" :id="`${scope.row.id}_feature`" v-html="scope.row.feature" style="margin-right: 4px;"></span>
            <zm-tooltip placement="top">
              <div slot="content" v-html="scope.row.tooltip" />
              <button data-testid="checkout-button-22" class="comparison-table__icon-btn" v-if="scope.row.tooltip" :aria-label="`Learn more about ${scope.row.feature}`" tabindex="-1">
                <span class="sr-only"> {{ $t('helpTooltipIcon') }}</span>
                <i class="zm-icon-info-outline primary-icon"></i>
              </button>
            </zm-tooltip>
          </span>
          <AutoExpireBadge :badgeId="scope.row.badgeId" theme="comparison" style="margin-left: 4px;" />
          <a data-testid="checkout-a-23" tabindex="-1" v-if="scope.row.pdf" href="https://zoom.us/docs/doc/Phone-NomadicE911-6-2020.pdf" target="_blank">{{$t('phone.fullPlanItem20Pdf')}}</a>
          <div v-if="scope.row.link">
            <a data-testid="checkout-a-24" tabindex="-1" v-if="scope.row.link.callback" href="javascript:void(0);" @click="scope.row.link.callback" :style="scope.row.link.style || {}" :aria-label="scope.row.link.ariaLabel||scope.row.link.text">{{scope.row.link.text}}</a>
          </div>
        </div>
      </template>
    </zm-table-column>
    <!--col config start-->
    <zm-table-column
      v-for="(col, idx) in colConfig"
      :key="col.key + idx"
      class-name="comparison-table__col"
      width="210">
      <!-- eslint-disable -->
      <template slot="header" slot-scope="scope">
        <div tabindex="-1" class="type-title">{{col.title}}</div>
        <template v-if="!col.hideBtn">
          <i tabindex="-1" v-if="col.category === value || col.selected" class="zm-icon-ok no-event-btn" :aria-label="col.title + ' Selected'"></i>
          <zm-tooltip v-else-if="col.btn && col.btn.disabledTips" :disabled="!col.btn.disabled">
            <p @click='onSubmitFormClick(col, $event)' slot="content" v-html="col.btn.disabledTips"/>
            <div>
              <zm-button data-testid="checkout-button-25" tabindex="-1" :type="col.btn.type" round @click="col.btn.callback(col)" :disabled="col.btn.disabled" :aria-label="col.btn.ariaLabel">{{ col.btn.label }}</zm-button>
            </div>
          </zm-tooltip>
          <zm-button data-testid="checkout-button-26" tabindex="-1" v-else-if="col.btn" :type="col.btn.type" round @click="col.btn.callback(col)" :disabled="col.btn.disabled" :aria-label="col.btn.ariaLabel">{{ col.btn.label }}</zm-button>
          <div v-else class="empty-btn" aria-hidden="true" />
        </template>
      </template>
      <template slot-scope="scope" v-if='!scope.row.footerDesc'>
        <template v-if="col.key !== 'enterprise'">
          <template v-if="scope.row.isString">
            <span tabindex="-1" v-html="scope.row[col.key]" v-if="scope.row[col.key]" ></span>
            <i tabindex="-1" class="zm-icon-minus"  :aria-label="$t('notIncluded')" v-else ></i>
          </template>
          <template v-else>
            <i tabindex="-1" class="zm-icon-ok primary-icon"  :aria-label="$t('included')" v-if="scope.row[col.key] == true"></i>
            <span tabindex="-1" v-html="scope.row[col.key]" v-else-if="scope.row[col.key] && scope.row.mixed && typeof scope.row[col.key] === 'string'" ></span>
            <i tabindex="-1" class="zm-icon-minus"  :aria-label="$t('notIncluded')" v-else></i>
            <template v-if="scope.row.desc">
              <div tabindex="-1" class="cell-desc" v-html="scope.row.desc" v-if="typeof scope.row.desc === 'string'"></div>
              <div tabindex="-1" class="cell-desc" v-html="scope.row.desc[col.key]" v-if="typeof scope.row.desc === 'object'"></div>
            </template>
          </template>
        </template>
        <template v-else>
          <template v-if="scope.row.isString">
            <span tabindex="-1" v-html="scope.row.enterprise" v-if="scope.row.enterprise"></span>
            <i tabindex="-1" class="zm-icon-minus"  :aria-label="$t('notIncluded')" v-else></i>
            <div tabindex="-1" class="cell-desc" v-if="scope.row.enterpriseDesc">*{{scope.row.enterpriseDesc}}</div>
          </template>
          <template v-else>
            <template v-if="scope.row.enterprise">
              <i tabindex="-1" v-if="scope.row.enterprise === true" class="zm-icon-ok primary-icon" :aria-label="$t('included')" ></i>
              <div v-else tabindex="-1">{{scope.row.enterprise}}</div>
              <div tabindex="-1" class="cell-desc" v-html="scope.row.enterpriseDesc" v-if="scope.row.enterpriseDesc"></div>
              <template v-if="scope.row.desc">
                <div tabindex="-1" class="cell-desc" v-html="scope.row.desc" v-if="typeof scope.row.desc === 'string'"></div>
                <div tabindex="-1" class="cell-desc" v-html="scope.row.desc[col.key]" v-if="typeof scope.row.desc === 'object'"></div>
              </template>
            </template>
            <i tabindex="-1" class="zm-icon-minus"  :aria-label="$t('notIncluded')" v-else></i>
          </template>
        </template>
      </template>
    </zm-table-column>
    <!--col config end-->
  </zm-table>
</template>
<script>
import { A_LINK_TAG_NAME } from '@/common/constants';

export default {
  props: {
    treeData: Array,
    colConfig: Array,
    value: String,
    width: {
      default: '944px',
    },
    maxHeight: {
      default: 500,
    },
  },
  methods: {
    arraySpanMethod({ row, columnIndex }) {
      if (row.subTitle) {
        return columnIndex === 0 ? [1, 10] : [0, 0];
      }
    },
    handleRowClick(row) {
      if (row.subTitle) {
        const featureCol = document.querySelector(`.${row.id}-sub-title`);
        let cel = null;
        let expandBtn = null;
        if (featureCol) {
          cel = featureCol.parentElement;
        }
        if (cel) {
          expandBtn = cel.querySelector('.zm-table__expand-icon');
        }
        if (expandBtn) {
          expandBtn.click();
        }
      }
    },
    onSubmitFormClick(col, event) {
      if (event?.target?.tagName === A_LINK_TAG_NAME) {
        this.$tracking.buyInteraction(
          'product details',
          `full plan comparison select - ${col?.category || ''} - contact form`);
      }
    },
  }
}
</script>

<style lang="scss">
.sr-only {
  position: absolute;
  width: 0px;
  height: 0px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.no-event-btn[class^="zm-icon-"] {
  color: #0B5CFF;
  height: 36px;
  line-height: 36px;
  &::before {
    font-size: 18px;
  }
}
.comparison-table {
  td a {
    color: #0e71eb;
    font-weight: 400;
    text-decoration: none;
  }
  th a {
    color: #0e71eb;
    font-weight: 400;
    text-decoration: none;
  }
  td,tr {
    padding: 0;
  }
  .cell {
    padding: 0;
  }
  td:first-child, .comparison-table th:first-child {
    padding-left: 38px;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
  }
  td:last-child, .comparison-table th:last-child {
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }
  [class*=zm-table__row--level] {
    .zm-table__expand-icon {
      position: absolute;
      right: 37px;
      font-size: 22px;
      line-height: 33px;
      color: #0B5CFF;
      width: 33px;
      height: 33px;
    }
  }
  .zm-table__placeholder {
    display: none;
  }
  &-header-cell.comparison-table__col {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 450;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: #00053D;
    padding-top: 0;
    padding-bottom: 0;
    &:first-child {
      padding-left: 38px;
    }
    .cell {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 13px 4px;
      .zm-button{
        font-family: 'Almaden Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 150%;
        &.zm-button--icon.no-event-btn {
          background: transparent;
          cursor: pointer;
          pointer-events: none;
          &:hover {
            background-color: transparent;
          }
          &:active {
            background-color: transparent;
          }
          &:focus {
            box-shadow: 0 0 0 2px transparent, 0 0 0 2px #0e72ed;
          }
        }
      }
    }
  }
  .comparison-table__feature-col {
    text-align: left;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 450;
    font-size: 16px;
    line-height: 150%;
    color: #00053D;
    padding: 20px 0;
    .sub-title {
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 22px;
      line-height: 33px;
      color: #0B5CFF;
      padding: 20px 0;

      &.sub-title__footer {
        color: #666487;
        font-size: 12px;
        line-height: 18px;
        font-weight: normal;
      }
    }
  }
  td.comparison-table__col {
    text-align: center;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 450;
    font-size: 16px;
    line-height: 150%;
    color: #00053D;
    padding: 20px 4px;
    .cell-desc {
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 150%;
      text-align: center;
      color: #666487;
      display: block;
      margin-top: 4px;
    }
    a {
      color: #0B5CFF;
    }
    .type-title{
      width: fit-content;
    }
  }
  &__icon-btn {
    background-color: transparent;
    border: none;
    font-size: 14px;
    line-height: 14px;
  }
  .primary-icon {
    color: #0B5CFF;
  }
  td.comparison-table__col, & td.comparison-table__feature-col {
    border: none;
  }
}
.empty-btn {
  height: 36px;
}
</style>
